// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","group":"Footer_group__fN6jE"};